import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import {SNACKBAR_DURATION} from '../../constants';

export default function SnackbarSuccess({isSnackbarOpen, toggleSnackbar, text}) {
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isSnackbarOpen}
      autoHideDuration={SNACKBAR_DURATION}
      onClose={() => toggleSnackbar(false)}
    >
      <Alert onClose={() => toggleSnackbar(false)} severity="success" sx={{width: '100%'}}>
        {text}
      </Alert>
    </Snackbar>
  );
}
